
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/punchout/oci/error",
      function () {
        return require("private-next-pages/punchout/oci/error.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/punchout/oci/error"])
      });
    }
  